import * as e from "react";
import c from "../lib/SSRBase.es.js";
import a from "../defs/Check.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(c, { ref: t, ...r, weights: a }));
o.displayName = "CheckIcon";
const f = o;
export {
  f as Check,
  o as CheckIcon
};
